module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-12.84d02cbb.jpg";